
import { useStore } from "../../state/state.ts";
import Measure from "../measure.tsx"
import ModalDach from "../../modals/modal_dach.tsx";
import ModalDachFuture from "../../modals/modal_dach_future.tsx";
import { MASSNAHMEN_DACH_OPTIONS_CURRENT_LABELS, MASSNAHMEN_DACH_OPTIONS_NEW_LABELS} from "../../state/types.ts";
import { useRef } from "react";

export default function MeasureWidgetDach() {
  // @ts-ignore:TS6133
  //const _properties = useStore((state)=>state.properties); //MUST EXIST FOR REACTIVITY TO WORK
  const dach = useStore((state)=>state.dach || "");
  const dach_future = useStore((state)=>state.dach_future  || "");
  const ref = useRef<HTMLButtonElement>(null);

  const push_modal = useStore((state) => state.push_modal_closeable);
  const is_step_id = useStore((state) => state.is_step_id);
    const measure_lables = useStore((state)=>state.measure_lables);

  const current = measure_lables[dach] || MASSNAHMEN_DACH_OPTIONS_CURRENT_LABELS[dach] || "" ;
  const future = measure_lables[dach_future] || MASSNAHMEN_DACH_OPTIONS_NEW_LABELS[dach_future] || "" ;
  return <Measure id="dach" measure_ref={ref} key={"measure-widget-dach"} label={"Dach"} now={current} future={future} onClick={() => push_modal(is_step_id("future")?<ModalDachFuture/>:<ModalDach/>, ref)} />;
}
